/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunCopperRing.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation2.play();
    actions.Animation2.repetitions = 1;
    actions.Animation2.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="copperRing" geometry={nodes.copperRing.geometry} material={materials['材質.002']} />
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunCopperRing.glb')
